import { createSelector } from 'reselect';
import { AppState } from '../../../types';
import { rootSelector as settingsRootSelector } from '../selectors';

export const rootSelector = createSelector(settingsRootSelector, settings => settings.webRecording);

/**
 * Returns the current webRecordingSettings.
 */
export const settingsSelector = createSelector(rootSelector, ({ settings }) => settings);

/**
 * Returns the current the boolean value of whether resource uploading is enabled or not.
 */
export const resourceUploadingEnabledSelector = createSelector(
  settingsSelector,
  data => data?.resourceUploadingEnabled,
);

export const settingsLoading = (state: AppState) =>
  state.settings.webRecording.settingsRequest.loading;
